<section>
  <div role="status">
    <div
      *ngIf="filterText || quickFilter || resourceTypeFilter"
      class="alert alert-warning c-list-alert"
    >
      <div
        *ngIf="resourceTypeFilter"
        class="qa-filter-alert--resource-type alert--flex c-list-alerts__filters"
      >
        <span i18n="@@listAlerts-status-filteredByResourceType">
          List filtered by resource type: {resourceTypeFilter.value, select,
          Article {Article} AudioDocument {Audio Document} AudioVisualDocument
          {Audio-visual document} Book {Book} Chapter {Chapter} Document
          {Document} Image {Image} Journal {Journal} LegalCaseDocument {Legal
          Case Document} LegalDocument {Legal Document} Legislation
          {Legislation} Score {Music Score} Page {Page} Presentation
          {Presentation} Proceedings {Proceedings} Thesis {Thesis} Video {Video}
          Webpage {Webpage} Website {Website} other
          {{{resourceTypeFilter.value}}}}
        </span>
        <button
          (click)="clearResourceTypeFilter.emit($event)"
          i18n="@@listAlerts-btn-clearResourceTypeFilter"
          type="button"
          class="btn btn-alert"
        >
          Clear filter
        </button>
      </div>

      <div
        *ngIf="quickFilter"
        id="quick-filter-alert"
        class="alert--flex c-list-alerts__filters"
      >
        <span class="qa-filtered-by" i18n="@@listAlerts-status-filteredBy"
          >List filtered by {quickFilter.type, select, importance {importance}
          readingIntention {reading intention} studyNotes {personal notes}
          resourceType {format} digitisationStatus {digitisation status}
          availability {bookstore}}:
          <rl-quick-filter-label
            [quickFilterId]="quickFilter.id"
            [quickFilterType]="quickFilter.type"
            [quickFilterValue]="quickFilter.value"
          >
          </rl-quick-filter-label>
        </span>
        <button
          (click)="clearQuickFilter.emit($event)"
          i18n="@@listAlerts-btn-clearFilter"
          type="button"
          class="btn btn-alert"
        >
          Clear filter
        </button>
      </div>

      <div
        *ngIf="filterText"
        id="text-filter-alert"
        class="alert--flex c-list-alerts__filters"
      >
        <span i18n="@@listAlerts-label-listFilteredBy"
          >List filtered by <em>{{ filterText }}</em>
        </span>
        <button
          (click)="clearTextFilter.emit($event)"
          i18n="@@listAlerts-btn-clearSearch"
          type="button"
          class="btn btn-alert"
        >
          Clear search
        </button>
      </div>
    </div>

    <div
      *ngIf="
        (filterText || quickFilter || resourceTypeFilter) &&
        hasVisibleEntries === false
      "
      class="alert alert-danger c-list-alert c-list-alerts__no-results"
    >
      <ng-container i18n="@@listAlerts-status-noResultsFound"
        >No results found!</ng-container
      >
    </div>
  </div>

  <div
    *ngIf="hasCitationErrors === true"
    class="alert alert-danger c-list-alert c-list-alerts__citation-errors"
    role="alert"
  >
    <ng-container>
      <strong i18n="@@listAlerts-status-error">Error</strong>
      <ng-container i18n="@@listAlerts-status-errorLoadingCitations"
        >We could not load citations for all items.</ng-container
      >
    </ng-container>
  </div>

  <div
    *ngIf="list.rolled_over_to?.is_published"
    class="alert alert--flex alert-warning c-list-alert c-list-alerts__rolled-over--published"
  >
    <span i18n="@@listAlerts-status-listHasNewerVersion"
      >This list has a newer version.</span
    >
    <a
      [href]="getListUrl(list.rolled_over_to.id)"
      class="btn btn-alert"
      i18n="@@listAlerts-link-viewNewerVersion"
      >View newer version</a
    >
  </div>

  <div
    *ngIf="list.rolled_over_to?.is_draft && isRolledOverListAdmin"
    class="alert alert--flex alert-warning c-list-alert c-list-alerts__rolled-over--draft"
  >
    <span i18n="@@listAlerts-status-listHasNewerDraftVersion"
      >This list has a newer draft version</span
    >
    <a
      [href]="getListUrl(list.rolled_over_to.id)"
      class="btn btn-alert"
      i18n="@@listAlerts-link-viewNewerDraftVersion"
      >View newer version</a
    >
  </div>

  <div
    *ngIf="list.is_archived"
    class="alert alert-danger c-list-alert c-list-alerts__archived"
  >
    <ng-container i18n="@@listAlerts-status-listArchived"
      >This list has been archived</ng-container
    >
  </div>

  <div
    *ngIf="hasTimePeriodExpired"
    class="alert alert-danger c-list-alert c-list-alerts__time-period--expired"
  >
    <ng-container>
      <strong i18n="@@listAlerts-status-warning">Warning</strong>
      <ng-container i18n="@@listAlerts-status-timePeriodEnded">
        This list relates to the term
        {{ editableList.period.description }} which ended on
        {{
          editableList.period.endAsDate | amLocale : locale | amDateFormat : 'L'
        }}
      </ng-container>
    </ng-container>
  </div>

  <div
    *ngIf="hasTimePeriodNotStarted"
    class="alert alert-warning c-list-alert c-list-alerts__time-period--not-started"
  >
    <ng-container i18n="@@listAlerts-status-timePeriodNotStarted">
      This list relates to the term {{ editableList.period.description }} which
      does not start until
      {{
        editableList.period.startAsDate | amLocale : locale | amDateFormat : 'L'
      }}
    </ng-container>
  </div>
</section>
